import { appSelectors } from '@appStore/reducers/app'
import { hasLinkedProfile } from 'features/linked-in-status'
import { useAppSelector } from 'shared/hooks'

function useLinkedInInfo() {
	const isImpersonated = useAppSelector(appSelectors.isImpersonated)
	const linkedInfo = useAppSelector(
		state => appSelectors.persona(state)?.linkedInProfile
	)
	const profile = useAppSelector(appSelectors.linkedProfile)
	const hasProfile = hasLinkedProfile(profile)
	const fallbackProfile = !isImpersonated && hasProfile ? profile : null
	const account = linkedInfo ?? fallbackProfile
	const id = account?.publicIdentifier || account?.entityId || null
	const result = { id, linkedInfo: account }
	return result
}

export { useLinkedInInfo }
